import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AbertaCasinoSportsList from '../components/AbertaCasinoSportsList';
import AlbertaFooter from '../components/AlbertaFooter';

function AbCasinoSports() {
  const [wowInitialized, setWowInitialized] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  useEffect(() => {
    const url = window.location.href;
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    const urlLink = params.get('url');
    
    if (urlLink) {
      setRedirecting(true);
      try {
        const decodedUrl = atob(urlLink);
        window.location.href = decodedUrl;
      } catch (error) {
        console.error('Error decoding URL:', error);
      }
    }
  }, []);

  useEffect(() => {
    // Load and initialize WOW.js animations
    const loadWOW = () => {
      if (window.WOW) {
        new window.WOW().init();
        setWowInitialized(true);
      } else {
        // Load WOW.js if not already loaded
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/wow/1.1.2/wow.min.js';
        script.integrity = 'sha512-Eak/29OTpb36LLo2r47IpVzPBLXnAMPAVypbSZiZ4Qkf8p/7S/XRG5xp7OKWPPYfJT6metI+IORkR5G8F900+g==';
        script.crossOrigin = 'anonymous';
        script.referrerPolicy = 'no-referrer';
        script.onload = () => {
          if (window.WOW) {
            new window.WOW().init();
            setWowInitialized(true);
          }
        };
        document.head.appendChild(script);
      }
    };

    loadWOW();
  }, []);

  // Reinitialize WOW.js when content changes (for dynamic content)
  useEffect(() => {
    if (wowInitialized && window.WOW) {
      // Small delay to ensure DOM is updated
      setTimeout(() => {
        new window.WOW().init();
      }, 100);
    }
  }, [wowInitialized]);

  return (
    <div className="App">
      {redirecting && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          fontSize: '18px',
          color: '#fff'
        }}>
          Redirecting securely.....
        </div>
      )}
      {!redirecting && (
        <>
          <Header />
          <Hero />
          <AbertaCasinoSportsList />
          <AlbertaFooter />
        </>
      )}
    </div>
  );
}

export default AbCasinoSports;

